import { formatDate } from '@airship-platform/airship-patterns';
import { Box } from '@mui/material';
import Alert from '@mui/material/Alert';
import { Link } from 'react-router';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import ROUTE_PATHS from '../../../routes/paths';

const ExpiredProposalAlert: React.FC = () => {
  const { currentProposal } = useAppointmentProposals();

  const expiryDate = currentProposal?.expiryDate;
  const isExpired = expiryDate && new Date(expiryDate) < new Date();
  if (!isExpired) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <Box>{`Proposal expired on ${formatDate(expiryDate)}`}.</Box>

      <Box>
        Options which were accepted can still be viewed by the customer.
      </Box>

      <Box>
        The expiry date is set in the{' '}
        <Link
          to={ROUTE_PATHS.APPOINTMENT_PATH({
            appointmentId: currentProposal.appointmentId,
            appointmentProposalId: currentProposal.appointmentProposalId,
            path: 'edit-presentation',
          })}
        >
          theme editor
        </Link>{' '}
        and can be extended if needed.
      </Box>
    </Alert>
  );
};

export default ExpiredProposalAlert;
